import { createApp } from 'vue';

import TestApp from "JIX/components/talenttest/TestApp.vue";
import createStore from "JIX/store/talenttest/talenttest.js";

const stash = window.Stash["talenttest/talenttest"];

const store = createStore(stash.data);

const app = createApp(TestApp);
app.use(store);
app.mount('#app');
